import axios from "axios";


export const http2013 = axios.create({
    baseURL: process.env.REACT_APP_IMAGE_PROCESSING,
  });